(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);
  document.addEventListener('DOMContentLoaded', function () {
    var icons = {
      leaf: "<svg viewBox='0 0 24 24' fill='none' stroke='%23c99a3f'><path d='M3 21c9-2 14-8 15-17-9 1-15 6-15 17z' stroke='%23c99a3f' stroke-width='1.5'/></svg>",
      link: "<svg viewBox='0 0 24 24' fill='none' stroke='%23c99a3f'><path d='M10 13a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-1 1' stroke='%23c99a3f' stroke-width='1.5'/><path d='M14 11a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l1-1' stroke='%23c99a3f' stroke-width='1.5'/></svg>",
      shield: "<svg viewBox='0 0 24 24' fill='none' stroke='%23c99a3f'><path d='M12 2l8 4v6c0 5-3.5 8-8 10-4.5-2-8-5-8-10V6l8-4z' stroke='%23c99a3f' stroke-width='1.5'/><path d='M8.5 12l2.5 2.5 4.5-5' stroke='%23c99a3f' stroke-width='1.5'/></svg>",
      phone: "<svg viewBox='0 0 24 24' fill='none' stroke='%23c99a3f'><path d='M4 4c0 9 7 16 16 16l2-4-5-2-2 2c-3-1-5-3-6-6l2-2-2-5z' stroke='%23c99a3f' stroke-width='1.5'/></svg>",
      envelope: "<svg viewBox='0 0 24 24' fill='none' stroke='%23c99a3f'><rect x='3' y='5' width='18' height='14' rx='2' stroke='%23c99a3f' stroke-width='1.5'/><path d='M3 7l9 6 9-6' stroke='%23c99a3f' stroke-width='1.5'/></svg>"
    };
 
    function svgSpan(name, size) {
      var span = document.createElement('span');
      span.className = 'footer-icon-heading';
      if (size) { span.style.width = size + 'px'; span.style.height = size + 'px'; }
      span.innerHTML = icons[name];
      return span;
    }
 
    document.querySelectorAll('.footer-block__heading').forEach(function (h) {
      var text = h.textContent.trim().toLowerCase();
      var iconName = null;
      if (text.indexOf('subscribe') !== -1) iconName = 'leaf';
      else if (text.indexOf('quick') !== -1 || text.indexOf('link') !== -1) iconName = 'link';
      else if (text.indexOf('polic') !== -1) iconName = 'shield';
      else if (text.indexOf('contact') !== -1) iconName = 'phone';
      if (iconName) {
        h.insertBefore(svgSpan(iconName), h.firstChild);
      }
    });
 
    document.querySelectorAll('.footer-block__details-content p, .footer-block__details-content div').forEach(function (el) {
      var text = el.textContent.trim();
      if (/^email\s*:/i.test(text)) {
        el.classList.add('footer-contact-line');
        var iconWrap = document.createElement('span');
        iconWrap.className = 'footer-contact-icon';
        iconWrap.innerHTML = icons.envelope.replace(/width='24' height='24'/, "width='16' height='16'");
        el.insertBefore(iconWrap, el.firstChild);
      } else if (/^phone\s*:/i.test(text)) {
        el.classList.add('footer-contact-line');
        var iconWrap2 = document.createElement('span');
        iconWrap2.className = 'footer-contact-icon';
        iconWrap2.innerHTML = icons.phone.replace(/width='24' height='24'/, "width='16' height='16'");
        el.insertBefore(iconWrap2, el.firstChild);
      }
    });
 
    var footerEl = document.querySelector('.footer');
    if (footerEl) {
      var leafL = document.createElement('div');
      leafL.className = 'footer-decor-leaf footer-decor-leaf--left';
      var leafR = document.createElement('div');
      leafR.className = 'footer-decor-leaf footer-decor-leaf--right';
      var wave = document.createElement('div');
      wave.className = 'footer-decor-wave';
      footerEl.appendChild(leafL);
      footerEl.appendChild(leafR);
      footerEl.appendChild(wave);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
